/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Slug
 */
export interface Slug {
  /**
   *
   * @type {Array<string>}
   * @memberof Slug
   */
  slugs: Array<string>
}

/**
 * Check if a given object implements the Slug interface.
 */
export function instanceOfSlug(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'slugs' in value

  return isInstance
}

export function SlugFromJSON(json: any): Slug {
  return SlugFromJSONTyped(json, false)
}

export function SlugFromJSONTyped(json: any, ignoreDiscriminator: boolean): Slug {
  if (json === undefined || json === null) {
    return json
  }
  return {
    slugs: json['slugs'],
  }
}

export function SlugToJSON(value?: Slug | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    slugs: value.slugs,
  }
}
